export const ANNOUNCEMENT_TYPES = [
  'Clinical',
  'Operational',
  'Administrative',
  'Other',
]

// Maps announcement types to the custom AmbuNet palette colours (Theme.jsx)
export const typeColor = (type) =>
  type === 'Clinical'
    ? 'anRed'
    : type === 'Operational'
      ? 'anBlue'
      : type === 'Administrative'
        ? 'anPurple'
        : 'anMainBlue'
